<template v-cloack>
	<div>
		<h1>{{$t('Subcapitulos')}}</h1>

		<div class="mt-5 mb-3">
			<div>
				<hotelDropdown v-show="user.role != 4" v-bind:append_to_body="false" v-bind:current_stay="''" v-on:onChangeHotel="onChangeHotel"></hotelDropdown>
			</div>

			<div v-if="user.role == 4">
                <h3>{{ user.staff_info.hvg_desc }}</h3>
            </div>
		</div>

		<vs-button v-if="!show_menus" ref="go_back_button" class="float-right" color="primary" type="filled" v-on:click="hideSubChapters()">{{$t('returnButton')}}</vs-button>

		<vx-card v-if="hotel_id != '' && menus.length == 0" class="mt-5">
			<div>
				<p align="center">{{$t('Não_foram_encontradas_cartas_para_o_hotel_selecionado')}}</p>
			</div>
		</vx-card>

		<div v-if="menus.length > 0" v-show="show_menus">
			<vs-divider color="primary" position="left">{{$t('Carta')}}</vs-divider>

			<vs-list v-for="(menu, key) in menus" :key="key" v-if="menu.type == 'Carta'">

				<vs-table :data="menu.idiomas">
					<vs-tr>
						<vs-td class="w-2/5">
							{{ menu.idiomas[0].name }}
						</vs-td>

						<vs-td class="w-2/5">
							<vs-button v-for="(item, index) in menu.idiomas" :key="index" color="success" type="line" line-origin="left" v-on:click="getIdiomas(menu, item, menu.currency, menu.type)"><strong>{{ item.language }}</strong></vs-button>
						</vs-td>
					</vs-tr>
				</vs-table>
			</vs-list>

			<vs-divider color="primary" position="left">{{$t('Menu')}}</vs-divider>

			<vs-list v-for="(menu, key) in menus" :key="key" v-if="menu.type == 'Menu'">

				<vs-table :data="menu.idiomas">
					<vs-tr>
						<vs-td class="w-2/5">
							{{ menu.idiomas[0].name }}
						</vs-td>

						<vs-td class="w-2/5">
							<vs-button v-for="(item, index) in menu.idiomas" :key="index" color="success" type="line" line-origin="left" v-on:click="getIdiomas(menu, item, menu.currency, menu.type)"><strong>{{ item.language }}</strong></vs-button>
						</vs-td>
					</vs-tr>
				</vs-table>
			</vs-list>

			<vs-divider color="primary" position="left">{{$t('Directório')}}</vs-divider>

			<vs-list v-for="(menu, key) in menus" :key="key" v-if="menu.type == 'Directório'">

				<vs-table :data="menu.idiomas">
					<vs-tr>
						<vs-td class="w-2/5">
							{{ menu.idiomas[0].name }}
						</vs-td>

						<vs-td class="w-2/5">
							<vs-button v-for="(item, index) in menu.idiomas" :key="index" color="success" type="line" line-origin="left" v-on:click="getIdiomas(menu, item, menu.currency, menu.type)"><strong>{{ item.language }}</strong></vs-button>
						</vs-td>
					</vs-tr>
				</vs-table>
			</vs-list>

			<vs-divider color="primary" position="left">{{$t('Marcação')}}</vs-divider>

			<vs-list v-for="(menu, key) in menus" :key="key" v-if="menu.type == 'Marcação'">

				<vs-table :data="menu.idiomas">
					<vs-tr>
						<vs-td class="w-2/5">
							{{ menu.idiomas[0].name }}
						</vs-td>

						<vs-td class="w-2/5">
							<vs-button v-for="(item, index) in menu.idiomas" :key="index" color="success" type="line" line-origin="left" v-on:click="getIdiomas(menu, item, menu.currency, menu.type)"><strong>{{ item.language }}</strong></vs-button>
						</vs-td>
					</vs-tr>
				</vs-table>
			</vs-list>

		</div>

		<div class="" v-if="selected_menu.id && chapters.length > 0" :key="selected_menu.id">
			<h3 class="pt-5">{{ selected_menu.name }} » {{ selected_menu.language }}</h3>
			<br>
			<vx-card class="w-full">
				<vs-tabs>
					<vs-tab v-for="(chapter, chapter_key) in activeItems(chapters)" :key="chapter_key" :label="chapter.name" v-on:click="clearChapter()">
						<div class="flex-wrap lg:flex">
							<div class="w-full lg:w-1/2">

							<h3 class="w-full">{{ updateMode ? 'Editar' : 'Novo' }}</h3>

							<vs-divider />

								<div>
									<vs-input class="w-full lg:w-4/5" v-model="sub_chapter.name" size="medium" :label="$t('nome')"/>
								</div>

								<div class="mt-3">
									<vs-textarea class="w-full lg:w-4/5" v-model="sub_chapter.description" size="medium" :label="$t('Descrição')"></vs-textarea>
								</div>

								<div v-if="['Directório', 'Marcação'].indexOf(type) === -1">
									<div v-show="has_measurements == 0 && sub_chapter.cod_menu_link === null" class="mb-3">
										<small class="block pl-1">Artigo de Vendaa</small>
										<v-select :append-to-body="true" class="w-full lg:w-4/5 vue-select" :clearable="false" :searchable="true" v-model="sub_chapter.sellable_item" v-on:input="setSellable_item()" :options="sellable_items_list" label="name">
										</v-select>
									</div>


									<div v-show="has_measurements == 0 && sub_chapter.cod_menu_link === null" class="mb-3">
										<vs-input class="w-full lg:w-2/5" type="number" v-model="sub_chapter.price" :value="sub_chapter.price" :label="$t('price')"/>
									</div>
									
									<div v-show="has_measurements == 0 && type == 'Carta'" class="mb-3">
										<small class="block pl-1">Cartas</small>
										<v-select :append-to-body="true" class="w-full lg:w-4/5 vue-select" :clearable="false" :searchable="true" v-model="sub_chapter.cod_menu_link" :options="cartas" :reduce="item => item.id" label="name">
										</v-select>
									</div>

									<small class="block mt-2">Logotipo</small>
									<v-select :append-to-body="true" class="w-full lg:w-4/5 vue-select mb-2" :clearable="false" :searchable="true" v-model="sub_chapter.logotipo" :options="logotipos" label="name" :multiple="true">
									</v-select>

									<div>
										<vs-input v-model="sub_chapter.order_by" type="number" min="0" class="w-full lg:w-2/5" :label="$t('Ordem_n')"/>
									</div>

									<div class="mb-5">
										<h4 class="dropdown_label label_price">{{$t('Medidas')}}</h4>
										<vs-switch :disabled="sub_chapter.cod_menu_link !== null" v-model="has_measurements" />
									</div>								

									<div v-if="has_measurements == 1">
										<div class="mb-3">
											<small class="block pl-1">{{$t('Artigo_de_Venda')}}</small>
											<v-select class="w-full lg:w-4/5 vue-select" :clearable="false" :searchable="true" v-model="sellable_item"  v-on:input="price = sellable_item.price ? sellable_item.price : ''" :options="sellable_items_list" label="name">
											</v-select>
										</div>

										<div class="mb-3">
											<vs-input class="w-full lg:w-2/5" type="number" v-model="price" :label="$t('price')"/>
										</div>

										<div class="mb-3">
											<vs-input class="w-full lg:w-2/5" type="number" v-model="volume" :label="$t('quantity')"/>
										</div>

										<div class="mb-3">
											<small class="block">Medida</small>
						                    <v-select class="vue-select lg:w-2/5 w-full" :append-to-body="true" :clearable="false" :searchable="false" v-model="medida" :options="medidas" label="name">
						                    </v-select>
										</div>

										<vs-button v-if="current_measure_index === ''" class="w-2/6 mb-8" color="success" type="border" v-on:click="addMeasure()">{{$t('Adicionar')}}</vs-button>

										<vs-button v-if="current_measure_index !== ''" class="w-2/6 mb-8" color="success" type="border" v-on:click="update_measure()">{{$t('Atualizar')}}</vs-button>

										<div v-if="sub_chapter.measures.length > 0" class="w-1/1 mt-5">
											<div v-for="(item, index) in sub_chapter.measures" :key="index">
												<div class="flex mb-5">
													<span class="mr-5 mt-3"><strong>{{ item.volume + '' + item.measure }}</strong></span>
													<span v-if="!isNaN(item.price) && item.price != null && item.price != ''" class="mr-5 mt-3"><strong>{{ item.price + ' ' + currency }}</strong></span>
													<span v-else class="mr-5 mt-3"><strong>---</strong></span>						
													<span class="mr-5 mt-3"><strong>{{ item.sellable_item_name }}</strong></span>
													<vs-button v-if="updateMode == false" type="filled" color="danger" size="small"  icon-pack="feather" icon="icon-x" v-on:click="removeMeasure(index)"></vs-button>

													<vs-button v-if="updateMode == true" class="float-right" color="primary" type="flat" icon-pack="feather" icon="icon-edit" v-on:click="edit_measure(index)"></vs-button>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="w-full">
									<div class="flex flex-wrap mb-5 -mx-1">
											<vs-button class="sm:w-full md:w-1/2 lg:w-1/3 m-1" color="success" type="filled" v-on:click="saveSubChapter(chapter)">{{$t('Gravar')}}</vs-button>
											<vs-button v-if="updateMode" class="sm:w-full md:w-1/2 lg:w-1/3 m-1" color="danger" type="filled" v-on:click="exit_edit_mode()">{{$t('cancels')}}</vs-button>
									</div>
								</div>
							</div>

							<div class="sm:w-full lg:w-1/2">
								<h3>{{$t('Subcapitulos')}}</h3>
								<vs-divider/>

								<p v-if="chapter.sub_capitulos.length == 0" align="center">
									{{$t('Não_foram_encontrados_subcapítulos')}}
								</p>
								<ul>
									<li :key="indextr" v-for="(item, indextr) in convertToBool(chapter.sub_capitulos)">
										<div class="flex">
											<div class="w-1/2">
												<strong><span v-if="item.order_by != 0">{{item.order_by}}º </span>{{ item.nome }}</strong>
												<br />
												<em>{{ item.descricao }}</em>
											</div>
											
											<div class="w-1/2">
												<div class="flex">
													<div class="w-3/4 align-middle">
														<div class="text-right align-middle" v-if="item.sub_capitulo_medidas.length <= 0" :dataparseFloat="(item.preco)">
															{{ item.preco != 0 ? parseFloat(item.preco).toFixed(2) + ' ' + currency : '' }}
														</div>

														<div class="text-right align-middle" v-if="item.sub_capitulo_medidas.length > 0" :data="item.sub_capitulo_medidas">
															<div class="text-right align-middle mb-2" v-for="(m, index) in convertToBool(item.sub_capitulo_medidas)" :key="index">
																{{ m.volume + ' ' + m.medida}}
																{{ (m.preco != '' && m.preco != 0 && m.preco != null) ? ' | ' + parseFloat(m.preco).toFixed(2) + ' ' + currency : '' }}
															</div>
														</div>
													</div>

													<div class="w-1/2 ml-2 align-middle">
														<vs-button class="inline-block -mt-3" color="primary" type="flat" icon-pack="feather" icon="icon-edit" v-on:click="enter_edit_mode(item)"></vs-button>
														<vs-button type="filled" color="danger" size="small" v-on:click="deleteSubChapter(chapter, item.id)" icon-pack="feather" icon="icon-x" class="inline-block ml-2"></vs-button>
													</div>
												</div>
											</div>
										</div>
										<vs-divider />
									</li>
								</ul>
							</div>
						</div>
					</vs-tab>
				</vs-tabs>
			</vx-card>		
		</div>
	</div>
</template>

<script>
/**
 * What you are about to see in the code below is a mix of bad decisions and a lot of changes, a lot.
 * I just don't have the time to fix this anymore so, i'm sorry and good luck.
 */

import HotelDropdown from '@/views/components/HotelDropdown.vue';
import draggable from 'vuedraggable';

export default {
	data() {
		return {
			hotel_id: '',
			warehouse_id: '',
			moedas: ['Euro', 'Real', 'Dollar'],
			type: '',
			currency: '',
			menus: [],
			sellable_items_list: [],
			chapters: [],
			selected_menu: {},
			sub_chapter: {
				visibility: 1,
				room_service: 0,
				sellable_item: '',
				price: '',
				name: '',
				order_by: '0',
				description: '',
				measures: [],
				id: '',
				logotipo: [],
			},
			show_menus: true,
			has_measurements: 0,
			medidas: [
				{short_name: '', name: '---'},
				{short_name: 'l', name: this.$t('Litro')},
				{short_name: 'dl', name: this.$t('Decilitro')},
				{short_name: 'cl', name: this.$t('Centilitro')},
				{short_name: 'ml', name: this.$t('Mililitro')},
				{short_name: 'min.', name: this.$t('Minuto')}
			],
			medida: '',
			volume: '',
			price: '',
			sellable_item: '',
			response: null,
			form_errors: [],
			measure_error: '',
			user: '',
			updateMode: false,
			measures_update: [],
			current_measure_index: '',
			editing: false,
			logotipos: [],
		}
	},
	watch: {
		has_measurements: function() {
			if(this.has_measurements == 1) {
				this.sub_chapter.sellable_item = this.sellable_items_list[0];
				this.sub_chapter.price = '';
				this.sub_chapter.cod_menu_link = null;
			}
		},
		sellable_items_list: function(new_val, old_val) {
			if(new_val.length > 0) {
				this.sellable_item = new_val[0];
				this.sub_chapter.sellable_item = new_val[0];
			}
			this.editing = false;
		}
	},
    methods: {
		setSellable_item() {
			if(this.sub_chapter.sellable_item != 0) {
				const price = this.sub_chapter.sellable_item.price
				this.setPrice(price)
			} else {
				this.setPrice('')
			}
		},

		convertToBool(arr) {
            arr.forEach(x => {
                x.visibility = x.visibility == 1 ? true : false;
            });
            return arr;
		},
		
        onChangeHotel(hotel_id) {
			this.hotel_id = hotel_id;
			this.hideSubChapters();
			this.clearChapter();
			this.getMenus(hotel_id);
		},

		setPrice(price) {
			this.$set(this.sub_chapter, 'price', price != '' ? parseFloat(price).toFixed(2) : '');
		},
		
		getIdiomas(menu, selected_languae, currency, type) {
			let that = this;
			this.getChapters(selected_languae, function() {
				if(that.selected_menu.id && that.chapters.length == 0) {
					that.$vs.notify({
						text: this.$t('Não_foram_encontrados_capítulos_para_o_idioma_seleccionado'),
						color:'danger',
						position:'bottom-right',
						iconPack: 'feather',
						icon:'icon-alert-triangle'
					});

					that.show_menus = true;

					that.hideSubChapters();

				} else {
					that.show_menus = false;

					if (currency) {
						if(currency == 'Euro'){
							that.currency = '€';
						} else if(currency == 'Real'){
							that.currency = 'R$';
						} else {
							that.currency = '$';
						}
					}
					that.type = type;
					that.warehouse_id = menu.warehouse_id;
					
					if(['Directório', 'Marcação'].indexOf(that.type) === -1) {
						that.getSellableItems(menu.hotel_id, menu.warehouse_id);
					}
				}
			});

		},
		validateMeasure() {
			const measure_errors = [];

			if (this.volume == '') {
				measure_errors.push(this.$t('O_campo_Quantidade_é_obrigatório'));
			}

			if (this.medida == '' || this.medida.short_name == '') {
				measure_errors.push(this.$t('O_campo_Medida_é_obrigatório'));
			}

			/*if (this.sellable_item == '') {
				measure_errors.push('O campo Artigo de Venda é obrigatório');
			}*/

			if (this.type == 'Carta' && this.sub_chapter.cod_menu_link === null) {
				if(/^D*$/i.test(this.price)) {
					measure_errors.push(this.$t('O_campo_Preço_deve_ser_numérico'));
				}
				if (this.price.length == 0) {
					measure_errors.push(this.$t('O_campo_Preço_é_obrigatório_e_deve_ser_numérico'));
				}
			}

			if(measure_errors.length > 0) {
				measure_errors.forEach(error => {
					this.$vs.notify({
						time: 4000,
						text: error,
						color:'danger',
						position:'bottom-right',
						iconPack: 'feather',
						icon:'icon-alert-triangle'
					});
				});

				return false;
			}
			return true;
		},
		addMeasure() {
			
			if(!this.validateMeasure()) {
				return;
			}

			this.sub_chapter.measures.push({ 
				measure: this.medida.short_name,
				volume: this.volume,
				price: (!isNaN(this.price)) ? this.price : '', 
				visibility: 1,
				room_service: 0,
				sellable_item: this.sellable_item.id ? this.sellable_item.id : '',
				sellable_item_name: this.sellable_item.id ? this.sellable_item.name : '---',
			});

			this.medida = this.medidas[0];
			this.volume = '';
			this.price = '';
			this.sellable_item = this.sellable_items_list[0];
		},

		removeMeasure(index) {
			this.sub_chapter.measures.splice(index, 1);
		},

		deleteSubChapter: function(chapter, id) {
			this.$vs.loading();
			let that = this;
			this.$api({
				method: 'post',
				url: '/myvilagale/hotel/sub-chapters/delete',
				params: {
					token: this.user.usertoken,
					id: id
				},
			})
			.then(function (res) {
				chapter.sub_capitulos = chapter.sub_capitulos.filter(item => item.id !== id);
				that.$vs.loading.close();
				that.$vs.notify({
					text: res.data.message,
					color:'success',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-check'
				});
			}) 
			.catch( function (err) {
				that.$vs.notify({
					text: that.$t('Ocorreu_um_erro_ao_eliminar_o_registo.'),
					color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});
				that.$vs.loading.close();
			});
		},
		
		hideSubChapters() {
			this.updateMode = false;
			this.show_menus = true;
			this.selected_menu = {};
			this.clearChapter();
			this.getMenus(this.hotel_id);
			this.chapters = [];
			this.type = '';
		},

		clearChapter() {
			this.sub_chapter = {
				visibility: 1,
				room_service: 0,
				sellable_item: this.sellable_items_list[0],
				price: '',
				name: '',
				order_by: '0',
				cod_menu_link: null,
				description: '',
				measures: [],
			}

			this.chapter = {};

			this.measure_error = '';
			this.has_measurements = false;
		},

		removeSubChapter(chapter_key, index) {		
			const arr = this.sub_chapter[chapter_key].slice(0);
			arr.splice(index, 1);
			this.$set(this.sub_chapter, chapter_key, arr);
		},
		
		saveSubChapter(chapter) {
			if (this.checkForm() == false) {
				return false;
			}

			let that = this;

			this.$vs.loading();

			if (this.has_measurements == true) {
				this.sub_chapter.sellable_item_id = 0;
			}

			this.sub_chapter.chapter_id = chapter.id;
			
			if(['Directório', 'Marcação'].indexOf(this.type) === -1 && !this.has_measurements) {
				this.sub_chapter.sellable_item_id = this.sub_chapter.sellable_item.id;
			}

			if(this.sub_chapter.cod_menu_link !== null) {
				this.sub_chapter.price = null;
				this.sub_chapter.measures = [];
				this.sub_chapter.sellable_item_id = null;
			}

			let params = { 
				sub_chapter: this.sub_chapter,
				hotel_id: this.hotel_id,
				currency: this.currency,
				has_measurements: this.has_measurements
			};

			let createUrl = '/myvilagale/hotel/' + this.hotel_id + '/menu/' + this.selected_menu.id + '/chapters/' + chapter.id + '/sub-chapters?token=' + localStorage.getItem('usertoken');

			let updateUrl = '/myvilagale/hotel/subchapter/update?token=' + localStorage.getItem('usertoken');
			this.$api.post(this.updateMode ? updateUrl : createUrl,
				params,
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
					}
				})
				.then(function(res) {
					that.getChapters(that.selected_menu)
					that.exit_edit_mode();

                    that.$vs.loading.close();
                    that.$vs.notify({
                        time: 4000,
                        text: that.updateMode ? that.$t('Registo_alterado_com_sucesso') : that.$t('Registo_criado_com_sucesso'),
                        color:'success',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-check'
					});
					
                })
                .catch(function() {
                    that.$vs.loading.close();
                    that.$vs.notify({
                        time: 4000,
                        text: that.updateMode ? that.$t('Ocorreu_um_erro_ao_alterar_o_registo') : that.$t('Ocorreu_um_erro_ao_criar_o_registo'),
                        color:'danger',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-alert-triangle'
                    });
                });
		},

		edit_measure(index) {
			this.current_measure_index = index;

			this.medida = this.medidas.find((item, idx) => item.short_name === this.sub_chapter.measures[index].measure);
			if(typeof this.medida === 'undefined') {
				this.medida = this.medidas[0];
			}
			this.volume = this.sub_chapter.measures[index].volume;
			this.price = this.sub_chapter.measures[index].price ? this.sub_chapter.measures[index].price : '';
			this.sellable_item = this.sellable_items_list.find(element => element.id == this.sub_chapter.measures[index].sellable_item);
			if(typeof this.sellable_item === 'undefined') {
				this.sellable_item = this.sellable_items_list[0];
			}
		},

		update_measure() {
			if(!this.validateMeasure()) {
				return;
			}

			this.sub_chapter.measures[this.current_measure_index].volume = this.volume;
			this.sub_chapter.measures[this.current_measure_index].measure = this.medida.short_name;
			this.sub_chapter.measures[this.current_measure_index].sellable_item = this.sellable_item.id;
			this.sub_chapter.measures[this.current_measure_index].price = this.price;
			this.sub_chapter.measures[this.current_measure_index].sellable_item_name = this.sellable_item.name;

			this.current_measure_index = '';
			this.medida = '';
			this.volume = '';
			this.price = '';
			this.sellable_item = this.sellable_items_list[0];
		},

		enter_edit_mode(sub_chapter) {
			
			this.exit_edit_mode();

			this.$vs.loading();

			this.editing = true;

			this.sub_chapter.id = sub_chapter.id;
			this.sub_chapter.name = sub_chapter.nome;
			this.sub_chapter.order_by = sub_chapter.order_by;
			this.sub_chapter.description = sub_chapter.descricao;
			this.sub_chapter.price = sub_chapter.preco != 0 ? sub_chapter.preco : '';
			this.sub_chapter.logotipo = sub_chapter.logotipo;
			this.sub_chapter.visibility = sub_chapter.visibility;
			this.sub_chapter.cod_menu_link = sub_chapter.cod_menu_link;
			this.sub_chapter.sellable_item = this.sellable_items_list.find(element => element.id == sub_chapter.artigo_venda);
			if(typeof this.sub_chapter.sellable_item === 'undefined') {
				this.sub_chapter.sellable_item = this.sellable_items_list[0]
			}
			this.has_measurements = sub_chapter.sub_capitulo_medidas.length > 0 ? 1 : 0;
			this.type_selected = this.selected_menu.type;
			this.updateMode = true;

			if(this.has_measurements == 1) {
				this.medida = this.medidas[0];
				sub_chapter.sub_capitulo_medidas.forEach(m => {
					this.sub_chapter.measures.push(
						{
							id: m.id,
							measure : m.medida,
							volume : m.volume,
							price : m.preco != 0 ? m.preco : '',
							visibility: m.visibility,
							room_service: m.room_service,
							sellable_item : m.artigo_venda ? m.artigo_venda : '',
							sellable_item_name : m.artigo_venda ? this.sellable_items_list.find(element => element.id == m.artigo_venda).name : '---',
						}
					)
				});
			}

			setTimeout(() => {
				this.$vs.loading.close();
			}, 1000);
		},

		exit_edit_mode() {
			this.getChapters(this.selected_menu)
			this.clearChapter();
			this.sub_chapter = {
				visibility: 1,
				room_service: 0,
				order_by: '0',
				sellable_item: this.sellable_items_list[0],
				price: '',
				name: '',
				description: '',
				cod_menu_link: null,
				measures: [],
				id: '',
				logotipo: [],
			};
			this.type_selected = '';
			this.measures_update = [];
			this.current_measure_index = '';
			this.current_measure_index = '';
			this.medida = '';
			this.volume = '';
			this.price = '';
			this.sellable_item = this.sellable_items_list[0];

			this.updateMode = false;
			this.editing = false;
		},

		checkForm() {
			const form_errors = [];

			if (!this.sub_chapter.name) {
				form_errors.push(this.$t('O_campo_Nome_é_obrigatório'));
			}

			if(['Directório', 'Marcação'].indexOf(this.type) === -1) {
				if (this.has_measurements == 1) {
					if (this.sub_chapter.measures.length <= 0) {
						form_errors.push(this.$t('Não_foram_adicionadas_medidas'));
					}
				} else {
					/*if (!this.sub_chapter.sellable_item && this.has_measurements == 0 && this.type == 'Carta') {
						form_errors.push('O campo Artigo de Venda é obrigatório.');
					}*/

					if (this.type == 'Carta' && this.has_measurements == 0  && this.sub_chapter.cod_menu_link === null) {
						if(/^D*$/i.test(this.sub_chapter.price)) {
							form_errors.push(this.$t('O_campo_Preço_deve_ser_numérico'));
						}

						if(!this.sub_chapter.price) {
							form_errors.push(this.$t('O_campo_Preço_é_obrigatório'));
						}
					}
				}
			}

			if (this.sub_chapter.order_by == '' || isNaN(this.sub_chapter.order_by) || parseInt(this.sub_chapter.order_by) < 0) {
				form_errors.push(this.$t('O_campo_Ordem_deve_ser_númerico_e_maior_ou_igual_a'));
			}

			if (form_errors.length > 0) {
				form_errors.forEach(error => {
					this.$vs.notify({
						time: 4000,
						text: error,
						color:'danger',
						position:'bottom-right',
						iconPack: 'feather',
						icon:'icon-alert-triangle'
					});
				});

				return false;
			} else {
				return true;
			}
		},
		getLogotipos(){
			let that = this;
			this.$api({
				method: 'get',
				url: '/myvilagale/logotipos/getLogotipos',
				params: {
					token: this.$user.usertoken,
				},
			})
			.then(function (res) {
				that.account = res.data;
				that.logotipos = res.data;
			}) 
			.catch( function (err) {
				this.notify(err.response.data.message, 'red', 10);
			})
			.then(function() {
				that.$vs.loading.close();
			});
		}
	},
	computed: {
		cartas: function() {
			let ret = [{id: null, name: '---'}];
			for(let m of this.menus) {
				if(['Carta', 'Menu'].indexOf(m.type) !== -1
					&& m.id !== this.selected_menu.menu_id
					&& m.visibility == 1) {
					ret.push({id: m.id, name: m.idiomas[0].name});
				}
			}
			return ret;
		}
	},
	created() {
		this.user = JSON.parse(window.localStorage.getItem('userSession'));
		this.getLogotipos();

		if (this.user.role == 4) {
			this.hotel_id = this.user.staff_info.hvg_id;
			this.getMenus(this.hotel_id);
		}
	},
    components: {
		HotelDropdown,
		draggable
    }
}
</script>

<style scoped>

	.main_element_title {
		margin-top: 25px;
	}

	.hotel_dropdown {
		margin-top: 25px;
		display: flex;
	}

	.type_dropdown {
		margin-top: 25px;
		display: flex;
	}

	.dropdown_label {
		color: #4A4E4F;
		margin-top: 9px;
		margin-right: 15px;
	}

	.dropdown_label_description {
		margin-top: 25px;
	}

	.input_information {
		width: 75%;
	}

	.information_block {
		display: flex;
	}

	.dropdown_label_information {
		margin-top: 25px;
	}

	.dropdown_label_name {
		margin-top: 25px;
	}

	.price_block {
		display: flex;
	}

	.label_price {
		margin-top: 25px;
	}

	.moeda_dropdown {
		margin-top: 25px;
		display: flex;
	}

	.main_element_title {
		color: #4A4E4F;
	}

	.visibility_block {
		margin-top: 25px;
	}

	.visibility li {
		width: 16.66%;
		text-align: center;
		color: #63C0BB;
		display: inline-block;
	}

</style>